import React from 'react'
import './styles.css'

const OPTION_LABELS = ['A', 'B', 'C', 'D']

const Question = (props) => {
    const { question } = props

    const options = [
        question.option1,
        question.option2,
        question.option3,
        question.option4,
    ]

    // `ans` arrives as a string from the API in some rows and a number in
    // others, so it is compared loosely-but-explicitly rather than with ==.
    const answerIndex = Number(question.ans)

    return (
        <li className='qb_question'>
            <div className='qb_question_head'>
                <span className='qb_question_no'>{props.index}</span>
                <div
                    className='qb_question_text'
                    dangerouslySetInnerHTML={{ __html: question.question }}
                />
            </div>

            <ul className='qb_options'>
                {options.map((opt, i) => {
                    const isAnswer = answerIndex === i + 1

                    return (
                        <li
                            key={i}
                            className={`qb_option ${isAnswer ? 'is_answer' : ''}`}
                        >
                            <span className='qb_option_label'>{OPTION_LABELS[i]}</span>
                            <span
                                className='qb_option_text'
                                dangerouslySetInnerHTML={{ __html: opt }}
                            />
                            {/* The correct answer was previously indicated by a pink
                                background alone. Colour on its own is invisible to a
                                colour-blind reader and disappears entirely in the
                                printed/PDF copy, so the state is also given a tick
                                and a text label. */}
                            {isAnswer ? (
                                <span className='qb_option_tag'>
                                    <i className='fa fa-check' aria-hidden='true'></i>
                                    Correct
                                </span>
                            ) : null}
                        </li>
                    )
                })}
            </ul>
        </li>
    )
}

export default Question
